import { createSelector } from "reselect";
import { woundsSectionSelector } from "../wounds_section_selector";

export const selectedDateSelector = createSelector(
  woundsSectionSelector,
  woundsSection => {
    return woundsSection.selectedDate;
  }
);
